import { Badge } from '@apollo/orbit';
import React from 'react';

import { assertUnreachableOrReturnDefault } from 'src/lib/assertUnreachable';
import { BuildPipelineTrackBadge } from 'src/lib/graphqlTypes/types';

export const BuildPipelineBadge = ({
  status,
  className,
}: {
  status: BuildPipelineTrackBadge;
  className?: string;
}) => {
  switch (status) {
    case BuildPipelineTrackBadge.DEPRECATED:
    case BuildPipelineTrackBadge.EXPERIMENTAL:
    case BuildPipelineTrackBadge.UNSUPPORTED:
      return (
        <Badge variant="warn" className={className}>
          {status}
        </Badge>
      );
    case BuildPipelineTrackBadge.LATEST:
      return (
        <Badge variant="info" className={className}>
          {status}
        </Badge>
      );
    default:
      return assertUnreachableOrReturnDefault(
        status,
        <Badge className={className}>{status}</Badge>,
      );
  }
};
